<template>
	<div class="side_navigation">
		<div class="scroller">
			<el-menu
				:default-active="activeIndex"
				:unique-opened="true"
				@select="handleSelect"
			>
				<!-- ip小黑屋管理 -->
				<el-submenu index="1">
					<template slot="title">
						<span>小工具</span>
					</template>
					<el-menu-item index="1-1">登录类型管理</el-menu-item>
					<el-menu-item index="1-2">激活卡管理</el-menu-item>
					<el-menu-item index="1-3">产品类型管理</el-menu-item>
					<el-menu-item index="1-9">权限管理</el-menu-item>
					<el-menu-item index="1-4">ip小黑屋管理</el-menu-item>
					<el-submenu index="1-5">
						<template slot="title">门户网站管理</template>
						<el-menu-item index="1-5-1">一级分类</el-menu-item>
						<el-menu-item index="1-5-2">二级分类</el-menu-item>
					</el-submenu>
					<el-submenu index="1-6">
						<template slot="title">日志统计管理</template>
						<el-menu-item index="1-6-1">训练异常日志</el-menu-item>
						<el-menu-item index="1-6-2">充值和消费统计</el-menu-item>
						<el-menu-item index="1-6-3">更新训练进度统计</el-menu-item>
						<el-menu-item index="1-6-4">科飞商城异常充值</el-menu-item>
						<el-menu-item index="1-6-5">充值账户异常</el-menu-item>
						<el-menu-item index="1-6-6">查询处方日志</el-menu-item>
					</el-submenu>
					<el-submenu index="1-7">
						<template slot="title">客服管理系统</template>
						<el-menu-item index="1-7-1">筛选条件管理</el-menu-item>
						<el-menu-item index="1-7-2">客服人员管理</el-menu-item>
					</el-submenu>
					<el-menu-item index="1-8">登录人员统计</el-menu-item>
				</el-submenu>
				<!-- ip小黑屋管理 end -->
				
				<!-- excel赠送记录 -->
				<el-submenu index="2">
					<template slot="title">
						<span>excel赠送记录</span>
					</template>
					<el-menu-item index="2-1">excel列表</el-menu-item>
					<el-menu-item index="2-2">赠送充值记录</el-menu-item>
				</el-submenu>
				<!-- excel赠送记录 -->
			</el-menu>
		</div>

		<div class="ft">版权所有@ <a href="http://www.uflyvision.com/" target="_blank">科飞视觉</a></div>
	</div>
</template>

<script>
	import { mapState } from "vuex"
	
	const PATH_LIST = [
		{
			index: "1-1",
			path: "/index/back_tools/login_type"
		}, {
			index: "1-2",
			path: "/index/back_tools/card"
		}, {
			index: "1-3",
			path: "/index/back_tools/product_type"
		}, {
			index: "1-9",
			path: "/index/back_tools/permission"
		}, {
			index: "1-4",
			path: "/index/back_tools/ip"
		}, {
			index: "1-5-1",
			path: "/index/back_tools/web_primary"
		}, {
			index: "1-5-2",
			path: "/index/back_tools/web_secondary"
		}, {
			index: "1-6-1",
			path: "/index/back_tools/log_training"
		}, {
			index: "1-6-2",
			path: "/index/back_tools/log_cost"
		}, {
			index: "1-6-3",
			path: "/index/back_tools/log_update_training"
		}, {
			index: "1-6-4",
			path: "/index/back_tools/log_mall_unusual"
		}, {
			index: "1-6-5",
			path: "/index/back_tools/log_recharge_account"
		}, {
			index: "1-6-6",
			path: "/index/back_tools/log_prescription"
		}, {
			index: "1-7-1",
			path: "/index/back_tools/customer_condition_manage"
		}, {
			index: "1-7-2",
			path: "/index/back_tools/customer_manage"
		},  {
			index: "1-8",
			path: "/index/back_tools/login_count"
		}, {
			index: "2-1",
			path: "/index/back_tools/excel_list"
		}, {
			index: "2-2",
			path: "/index/back_tools/excel_record"
		}
	];
	export default {
		data () {
			return {
				activeIndex: ""
			}
		},
		computed: {
			...mapState([
				'authInfo'
			])
		},
		created () {
			this.initActiveIndex();
		},
		methods: {
			initActiveIndex () {
				const that = this;
				var _path = this.$route.path,
					_category = this.authInfo.ucategory;
				if (_category != 1) {
					that.$router.replace({
						path: '/index'
					});
					return false;
				}
				PATH_LIST.forEach((v) => {
					v.path == _path && (that.activeIndex = v.index);
				});
			},
			handleSelect (key) {
				var _path,
					_currentPath = this.$route.path;
				PATH_LIST.forEach((v) => {
					v.index == key && (_path = v.path);
				});
				_currentPath != _path && this.$router.push({path: _path});
			}
		},
		watch: {
			$route(){
				this.initActiveIndex();
			}
		}
	}
</script>

<style>
	.back_tools_page .side_navigation{ display: block;position: absolute;z-index: 99;width: 220px;height: 100%;top: 0;left: 0;padding-bottom: 48px;background: #fff; }
	.back_tools_page .side_navigation:after{ content: "";display: block;position: absolute;width: 1px;height: 100%;top: 0;right: 0;background: #ccc; }
	.back_tools_page .side_navigation .scroller{ display: block;width: 100%;height: 100%;background-color: rgb(84, 92, 100);overflow-y: auto; }
	.back_tools_page .side_navigation .scroller::-webkit-scrollbar { display:none; }
	.back_tools_page .side_navigation .ft{ position: absolute;width: 100%;height: 48px;bottom: 0px;padding: 10px 15px;font-size: 12px;text-align: center;line-height: 28px; }
	.back_tools_page .side_navigation .ft:before{ content: "";display: block;position: absolute;width: 100%;height: 1px;top: 0;left: 0;background: #ccc; }
	.back_tools_page .side_navigation .ft a{ color: #30a5ff; }
	.back_tools_page .side_navigation .ft a:hover{ text-decoration: underline; }
	
	.back_tools_page .side_navigation .el-menu{ border-right: none;background: transparent; }
	.back_tools_page .side_navigation .el-submenu{ margin-top: 5px;  }
	.back_tools_page .side_navigation .el-submenu:first-child{ margin-top: 0; }
	.back_tools_page .side_navigation .el-submenu__title{ height: 40px;color: #fff;line-height: 40px; }
	.back_tools_page .side_navigation .el-submenu__icon-arrow{ font-size: 18px;color: #fff; }
	.back_tools_page .side_navigation .el-menu-item{ height: 40px;color: #fff;line-height: 40px; }
	.back_tools_page .side_navigation .el-menu-item.is-active{ background: #409EFF; }
	.back_tools_page .side_navigation .el-submenu__title:hover,.back_tools_page .side_navigation .el-menu-item:hover{ background: #409EFF; }
</style>
